const STATUSES =
    Object.freeze(
        {
            UNFINISHED: -1,
            PENDING: 0,
            APPROVED: 1,
            REJECTED: 2,
        }
    );

export default STATUSES;
